export const PreventiveMaintenanceTriggerConditionType = {
  TIME: 'TIME',
  METER: 'METER',
} as const;

export type PreventiveMaintenanceTriggerConditionType =
  (typeof PreventiveMaintenanceTriggerConditionType)[keyof typeof PreventiveMaintenanceTriggerConditionType];
